const TrandingSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.668 15.8359C12.1157 15.8359 11.668 15.3882 11.668 14.8359V5.16441C11.668 4.61212 12.1157 4.16441 12.668 4.16441H15.6701C16.2223 4.16441 16.6701 4.61213 16.6701 5.16441V14.8359C16.6701 15.3882 16.2223 15.8359 15.6701 15.8359H12.668Z"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.33203 13.3359C3.77975 13.3359 3.33203 12.8882 3.33203 12.3359L3.33203 7.66649C3.33203 7.11421 3.77975 6.66649 4.33203 6.66649H7.33412C7.8864 6.66649 8.33411 7.11421 8.33411 7.66649V12.3359C8.33411 12.8882 7.8864 13.3359 7.33411 13.3359H4.33203Z"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.6707 10.0028H8.33594"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.1707 17.5033V15.8359"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.83481 6.6684V2.5"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.83481 13.3359V17.5043"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.1707 4.16736V2.5"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default TrandingSvg;
